import React from 'react';
import * as _ from 'lodash';
import { FieldService } from '../../../services/Fields';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { checkSelectedAll } from '../../../utilities/commonUtil';
import {
  DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT,
  REQUEST_PARAMS
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

export class CsvFieldDropdownMulti extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      opened: false,
      selected: [],
      options: {},
      condition: {
        name: '',
      },
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-field-multi-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getFields = this.getFields.bind(this);
    this.parent = React.createRef();
    this.searchTimer;
  }

  componentDidMount() {
    if (this.props.isPermitted) {
      this.getFields(() => {});
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.isPermitted, this.props.isPermitted)) {
      this.getFields(() => {});
    }
    if (this.state.opened === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.props.refreshed) {
      this.setState({
        opened: false,
        selected: [],
      });
    }

    if (!_.isEqual(prevProps.branchIds, this.props.branchIds)) {
      this.setState(
        {
          loaded: false,
          opened: false,
          options: {},
        },
        () => {
          this.getFields(() => {});
        }
      );
    }

    if (!_.isEqual(prevProps.selectAllBranches, this.props.selectAllBranches)) {
      this.setState(
        {
          loaded: false,
          opened: false,
          options: {},
          selected: [],
        },
        () => {
          this.getFields(() => {});
        }
      );
    }

    if (!_.isEqual(prevProps.selected, this.props.selected)) {
      this.setState({
        opened: false,
        selected: this.props.selected,
      });
    }
  }

  shouldComponentUpdate(nextProps) {
    if (
      !_.isEqual(this.props.selected, nextProps.selected) &&
      this.state.opened
    ) {
      return false;
    } else {
      return true;
    }
  }

  getFields(notify) {
    if (this.state.loaded) {
      notify();
      return;
    }

    // 「すべての支店を選択する」がfalseの場合、
    // そして支店が全く選択されてない場合何も取得しない
    if (
      _.isEmpty(this.props.branchIds) &&
      this.props.selectAllBranches === false
    ) {
      notify();
      return;
    }

    const params = {
      company_branch_ids: !_.isEmpty(this.props.branchIds)
        ? this.props.branchIds
        : null,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      isQuiet: true,
    };

    FieldService.listForOutputCsv(params).then(response => {
      if (response.result) {
        const fields = response.data.entities.fields;
        this.props.setList('fieldList', fields);
        if (_.isEmpty(fields)) {
          this.setState({ loaded: true });
        } else {
          let { options } = _.cloneDeep(this.state);
          _.each(fields, field => {
            options[field.id] = field;
          });
          this.setState({
            options,
            loaded: false,
          });
          this.handleToggleSelectAll(this.state.selected, options);
        }
      }
      notify();
    });
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  handleOpen = () => {
    if (!this.props.disabled) {
      if (!this.state.opened) {
        this.handleToggleSelectAll(this.state.selected, this.state.options);
      }
      this.setState({ opened: !this.state.opened });
    }
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search();
      }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
    });
  };

  search = () => {
    let state = this.state;
    state.options = {};
    state.loaded = false;
    this.setState(state);

    this.getFields(() => {});
  };

  handleSelectedRow = (fieldId, checked) => {
    let { selected } = _.cloneDeep(this.state);
    if (checked) {
      selected.push(parseInt(fieldId));
    } else {
      selected = [];
      _.each(this.state.selected, field => {
        if (field !== fieldId) {
          selected.push(field);
        }
      });
    }
    this.handleToggleSelectAll(selected, this.state.options);
    this.setState({ selected }, () => {
      this.props.set('field_ids', selected);
    });
  };

  handleSelectedAll = e => {
    let selected = [];
    if (e.target.checked) {
      _.each(this.state.options, field => {
        selected.push(parseInt(field.id));
      });
    }

    this.setState({ selected }, () => {
      this.props.set('field_ids', selected);
    });
  };

  isSelected(fieldId) {
    let bool = false;
    if (_.indexOf(this.state.selected, fieldId) !== -1) {
      bool = true;
    }
    return bool;
  }

  handleToggleSelectAll = (selecteds, options) => {
    document.querySelector(`#checkall-field-${this.id}`).checked = checkSelectedAll(selecteds, _.map(options, 'id'));
  };

  render() {
    const { selected } = this.state;
    const { selectedFields } = this.props;
    const dropdownLabel =
      _.isEmpty(selected)
        ? '選択してください'
        : _.join(_.map(selectedFields, 'name'), ',');

    return (
      <div className='form-list__element-csv-request-dropdown'>
        <div
          id='form-dropdown'
          className='dropdown-multi-select'
          ref={this.parent}
        >
          <div
            className={`dropdown-multi-select__header ${
              this.state.opened ? 'show' : ''
            }`}
          >
            <div
              id='form-dropdown-btn'
              className='dropdown-select'
              onClick={() => this.handleOpen()}
            >
              <span className='dropdown-select__txt dropdown-select__txt_ellipsis'>
                {dropdownLabel}
              </span>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </div>
          </div>
          <div
            id='form-dropdown-list'
            className={
              this.state.opened
                ? 'dropdown dropdown--dropdown-multi-select show'
                : 'dropdown dropdown--dropdown-multi-select dropdown--closed'
            }
          >
            <div className='dropdown__item dropdown__item--wide'>
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  onChange={e => this.setCondition(e)}
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-multi-select__item'>
                <div className='dropdown-multi-select__checkall'>
                  <div className='btn-checkbox'>
                    <label htmlFor={`checkall-field-${this.id}`}>
                      <input
                        id={`checkall-field-${this.id}`}
                        type='checkbox'
                        onChange={e => this.handleSelectedAll(e)}
                      />
                      <i className='i-square-checkbox i-2_5x' />
                    </label>
                  </div>
                  <label htmlFor={`checkall-field-${this.id}`}>
                    {messageUtility.getMessage('I-000-092')}
                  </label>
                </div>
              </div>
              <div className='dropdown-multi-select__scroll' id={this.targetId}>
                <ul id='dropdown-multi-select-list' className='multi-select'>
                  {_.map(this.state.options, (option, index) => (
                    <SelectableOption
                      key={index}
                      option={option}
                      checked={this.isSelected(option.id)}
                      targetId={this.id}
                      handleSelectedRow={this.handleSelectedRow}
                    />
                  ))}
                  <InfinityScrollLoad
                    targetId={this.targetId}
                    total={_.size(this.state.options)}
                    callback={this.getFields}
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='multi-select__item'>
    <div className='checkbox'>
      <label htmlFor={`multi-select-field-id-${option.id}-${targetId}`}>
        <input
          id={`multi-select-field-id-${option.id}-${targetId}`}
          type='checkbox'
          checked={checked}
          onChange={() => handleSelectedRow(option.id, !checked)}
        />
        <i className='i-square-checkbox i-2_5x' />
      </label>
    </div>
    <div
      className='multi-select__label'
      onClick={() => handleSelectedRow(option.id, !checked)}
    >
      {option.name}
    </div>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/CsvField.jsx